import { type QueryHookOptions, useQuery } from "@apollo/client";
import { TagTypeQuery } from "../graphql/queries";
import type { TagTypeQueryType } from "@/types/graphql/partner.generated";

export const useTagTypeQuery = (
  options?: QueryHookOptions<TagTypeQueryType>
) => {
  return useQuery<TagTypeQueryType>(TagTypeQuery, options);
};
